import { Injectable, Injector } from '@angular/core';
import { StorageManagerProvider } from '../storage-manager/storage-manager';
import { AbstractChatMessage } from '../../bayadic-shared-models/classes/message/abstract-chat-message';
import { SocketQuery } from '../../bayadic-shared-models/classes/system/sockets/SocketQuery.class';
import * as Enums from '../../bayadic-shared-models/enums/Enums';
import { AdsService } from '../ads-manager/ads-service';
import { TimeManagerProvider } from '../../providers/time-manager/time-manager';
import { AppStateManagerProvider } from '../../providers/app-state-manager/app-state-manager';
import { SocketResponse } from '../../bayadic-shared-models/classes/system/sockets/SocketResponse.class';
import { Events } from '../../providers/events/events';
import { Observable } from 'rxjs';
import { io, Socket } from "socket.io-client";
import { DefaultEventsMap } from '@socket.io/component-emitter';
import { environment } from '../../environments/environment';
import { CachingFilter } from '../../bayadic-shared-models/classes/caching-models/cache-filter';
import { LoggerService } from '../../app/services/logger.service';

@Injectable()
export class SocketManagerProvider {
    public websocket_server: Socket<DefaultEventsMap, DefaultEventsMap>;
    public websocket_server_insecure;
    public connected: boolean;
    public que: Array<SocketQuery>;
    public connectingStatusText = 'connecting...';
    public triedConnectionTimes = 10;
    public isConnecting = false;
    public addressServerTest = '';
    public addressServerOriginal = '';
    public insecureSocketAddress = '';
    public addressServerIP = '';
    public webserverAddress: string;
    public insecureSocket: string;
    public queries: Array<SocketQuery>;
    public static isOnline = false;
    public debug = false;
    networkAvailability: boolean;
    public waitForConnectionFunc: { (value: boolean | PromiseLike<boolean>): void; resolve?: any; };
    accessToken: string;
    requestQues: Array<SocketQuery> = [];
    loggedIn: boolean = false;
    alreadyFlushed: boolean = false;
    private cache = new Map<string, { data: any, timestamp: number }>();
    private readonly MAX_CACHE_SIZE = 1000; // Maximum number of cache entries
    private readonly MAX_CACHE_AGE = 7 * 24 * 60 * 60 * 1000; // 7 days in milliseconds

    constructor(
        public injector: Injector,
        public storageManager: StorageManagerProvider,
        public adsManager: AdsService,
        public appStateManager: AppStateManagerProvider,
        public timeManager: TimeManagerProvider,
        public events: Events,
        private logger: LoggerService
    ) {
        this.webserverAddress = environment.apiAddress;
        this.insecureSocket = environment.apiAddress;
        this.queries = [];
        this.que = [];
        this.connected = false;
        this.setNetwork(true);

        this.registerEvents();
        this.loadCacheFromStorage();

    }
    public registerEvents() {
        this.connect();
        // this.events.subscribe('checkOnline', () => {
        //     if (this.isNetwork()){
        //         this.checkOnline();
        //     }
        // });
        // this.events.subscribe('ping', () => {
        //     // this.sendMsg('ping', this);
        // })
    }
    private loadCacheFromStorage() {
        const storedCache = localStorage.getItem('socket-cache');
        if (storedCache) {
            const parsedCache = JSON.parse(storedCache);
            parsedCache.forEach((item) => {
                this.cache.set(item.key, item.value);
            });
        }
    }

    private saveCacheToStorage() {
        try {
            // Clean up expired entries first
            this.cleanupCache();
            
            const cacheArray = Array.from(this.cache.entries())
                .map(([key, value]) => ({
                    key,
                    value
                }));

            // If cache is too large, remove oldest entries
            if (cacheArray.length > this.MAX_CACHE_SIZE) {
                cacheArray.sort((a, b) => a.value.timestamp - b.value.timestamp);
                cacheArray.splice(0, cacheArray.length - this.MAX_CACHE_SIZE);
            }

            localStorage.setItem('socket-cache', JSON.stringify(cacheArray));
        } catch (error) {
            if (error.name === 'QuotaExceededError') {
                // If we still get quota exceeded, try to clear some space
                this.clearOldCache();
                try {
                    localStorage.setItem('socket-cache', JSON.stringify([]));
                } catch (e) {
                    this.logger.error('Failed to save cache to storage after cleanup', e);
                }
            } else {
                this.logger.error('Error saving cache to storage', error);
            }
        }
    }

    private cleanupCache() {
        const now = Date.now();
        for (const [key, value] of this.cache.entries()) {
            if (now - value.timestamp > this.MAX_CACHE_AGE) {
                this.cache.delete(key);
            }
        }
    }

    private clearOldCache() {
        const cacheArray = Array.from(this.cache.entries())
            .map(([key, value]) => ({
                key,
                value
            }))
            .sort((a, b) => a.value.timestamp - b.value.timestamp);

        // Keep only the most recent 20% of entries
        const keepCount = Math.floor(this.MAX_CACHE_SIZE * 0.2);
        const entriesToKeep = cacheArray.slice(-keepCount);
        
        this.cache.clear();
        entriesToKeep.forEach(entry => {
            this.cache.set(entry.key, entry.value);
        });
    }

    private isCacheExpired(timestamp: number): boolean {
        return Date.now() - timestamp > this.MAX_CACHE_AGE;
    }

    private getCacheKey(socketQuery: SocketQuery): string {
        const action = socketQuery.action;
        const data = JSON.stringify(socketQuery.data); // Serialize data to make it a string
        return `${action}:${data}`;
    }

  
    private setNetwork(isNetwork: boolean) {
        this.networkAvailability = isNetwork;
    }
    private isNetwork() {
        return this.networkAvailability;
    }
    public checkOnline() {
        if (!SocketManagerProvider.isOnline) {

            this.connect()
        }
        else{
            this.logger.debug("it is connected")
        }
    }
    public getOnlinePrime() {
        if (!SocketManagerProvider.isOnline) {
            // this.connect();
            this.logger.debug("wanted to connect but comment11")
        }
    }
    onOpen() {
        this.events.publish(Enums.EVENTS_Locally.Connected);
    }
    onError() {
        this.isConnecting = true;
        // smgr.changeServerAndConnect();

        //            smgr.tryConnect(smgr);
    }
    onClose(e) {
        this.events.publish(Enums.EVENTS_Locally.SocketDisconnected);
        this.logger.debug('cloosed socket', e);
        this.isConnecting = true;
        SocketManagerProvider.isOnline = false;
        //            smgr.tryConnect(smgr);
    }

    async connect() {
        if (this.connected || this.isConnecting){
            this.logger.debug("is conencting or connected")
            return true;
        }
        this.isConnecting = true;
        await this.initSocket();
        this.isConnecting = false;
    }
    changeServerAndConnect() {
        if (this.webserverAddress == this.addressServerOriginal) {
            this.webserverAddress = this.addressServerIP;
        }
        else if (this.webserverAddress == this.addressServerIP) {
            this.webserverAddress = this.addressServerOriginal;
        }
        /*
        setTimeout(()=>{
            this.connect();
        },2);*/
    }

    addQuery(socketQuery: SocketQuery) {
        this.que.push(socketQuery);
    }
    setConnected(connected: boolean) {
        this.connected = connected;
        this.isConnecting = false;
        SocketManagerProvider.isOnline = connected;
    }
    hanldeMessage(data) {
        this.logger.debug(data, 'is recevied data is');
    }
    handleIncomingMessages<T>(incomingMessage: SocketResponse<T>) {
        this.logger.debug("inc", incomingMessage)

        let originalSQuery = this.findOriginalSQuery(incomingMessage.queryId);

        if (originalSQuery) {
            let queryIndex = this.queries.indexOf(originalSQuery);
            this.queries.splice(queryIndex, 1);
            originalSQuery.resolve(incomingMessage.data);
        }
    }
    findOriginalSQuery(socketQueryId: string): SocketQuery {
        return this.queries.find((sQuery) => sQuery.id == socketQueryId);
    }
    onConnect(){
        this.logger.debug("client connected")
        this.setConnected(true);   
        for(let sQuery of this.queries){
            this.send(sQuery)
        }
    }
    async initSocket(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.logger.debug("initing websocket")

            this.websocket_server = io(this.webserverAddress);
            this.websocket_server.on('message', (data: SocketResponse<any>) => this.handleIncomingMessages(data));
            this.websocket_server.on("connect", () => {
                this.onConnect()
                resolve(true)
            });
            this.websocket_server.on("connect_error", (err) => {
                this.logger.debug("client error", err)
                this.setConnected(false)
                resolve(false)
            });

            this.websocket_server.on("disconnect", () => {
                this.logger.debug("client disconnected")
                this.isConnecting = true;
                this.setConnected(false);
            });
        })
    }
    disconnect() {
        this.websocket_server.close();
    }
    getMessage() {
        return this.connectingStatusText;
    }

    asyncQuery<GENERIC_RESPONSE, GEENRIC_REQUEST>(action: string, data?: GEENRIC_REQUEST, requiredogin: boolean = false): Promise<GENERIC_RESPONSE> {
        return new Promise(async (resolve, reject) => {
            const socketQuery = new SocketQuery(data, action, requiredogin);
            const cacheKey = this.getCacheKey(socketQuery);
            this.logger.debug("request cache key", cacheKey)
            // Check in-memory cache
            if (CachingFilter.isActionCacheable(action)) {
                this.logger.debug("is action cachable", action)

                if (this.cache.has(cacheKey)) {
                    const cachedResponse = this.cache.get(cacheKey);
                    if (this.isCacheExpired(cachedResponse.timestamp)) {
                        this.cache.delete(cacheKey);
                        this.saveCacheToStorage();
                    } else {
                        resolve(cachedResponse.data);
                        return;
                    }
                }

                // Check in localStorage
                const storedCache = localStorage.getItem('socket-cache');
                if (storedCache) {
                    const parsedCache = JSON.parse(storedCache);
                    const cachedItem = parsedCache.find(item => item.key === cacheKey);
                    if (cachedItem && !this.isCacheExpired(cachedItem.value.timestamp)) {
                        resolve(cachedItem.value.data);
                        return;
                    }
                }
            }

            socketQuery.setResolvable(true);
            this.send(socketQuery);
            this.queries.push(socketQuery);
            socketQuery.resolve = (response) => {
                this.cache.set(cacheKey, { data: response, timestamp: Date.now() });
                this.saveCacheToStorage();
                resolve(response);
            };
        });
    }
    getMainAccessToken() {
        if (!this.accessToken)
            this.logger.warn("no accessToken set for socket manager");

        return this.accessToken
    }
    async waitForConnection(): Promise<boolean> {
        if (this.connected) { return (true) }
        this.connect();
    }


    public send(socketQuery: SocketQuery): void {
        this.logger.debug("socket query", socketQuery)
        if (this.connected && !this.mustWaitForLogin(socketQuery) ) {
            let jsonData = {
                'action': socketQuery.action,
                'data': socketQuery.data,
                'query': socketQuery,
                'accessToken': this.getMainAccessToken()
            };
            this.logger.debug("sending data", jsonData)
            let sentData = JSON.stringify(jsonData);
            this.websocket_server.emit('message', sentData);
        }
        else {
            this.logger.debug("sending data")
            this.requestQues.push(socketQuery)
        }
    }
    onLoggedIn() {
        this.loggedIn = true;
        if(!this.requestQues){
            return false;
        }
        if(!this.connected){
            return false;
        }
        this.flushQue();

    }
    flushQue() {
        if(this.alreadyFlushed) return;
        this.alreadyFlushed = true

        for (let sQuery of this.requestQues) {
            let sQuery2 = this.requestQues.shift();
            sQuery2.requiredLogin = false;
            this.send(sQuery2);
        }
    }
    mustWaitForLogin(socketQuery: SocketQuery) {
        if(this.loggedIn) return false;
        if(socketQuery.requiredLogin) return true;
    }

}
